module.exports = __webpack_public_path__ + "static/media/search.46478b39.svg";